module.exports = {
  'AD.1': require('./AD.1.json'),
  'AD.2': require('./AD.2.json'),
  'AD.3': require('./AD.3.json'),
  'AD.4': require('./AD.4.json'),
  'AD.5': require('./AD.5.json'),
  'AD.6': require('./AD.6.json'),
  'AD.7': require('./AD.7.json'),
  'AD.8': require('./AD.8.json'),
  'AD': require('./AD.json'),
  'AUI.1': require('./AUI.1.json'),
  'AUI.2': require('./AUI.2.json'),
  'AUI.3': require('./AUI.3.json'),
  'AUI': require('./AUI.json'),
  'CCD.1': require('./CCD.1.json'),
  'CCD.2': require('./CCD.2.json'),
  'CCD': require('./CCD.json'),
  'CCP.1': require('./CCP.1.json'),
  'CCP.2': require('./CCP.2.json'),
  'CCP.3': require('./CCP.3.json'),
  'CCP': require('./CCP.json'),
  'CD.1': require('./CD.1.json'),
  'CD.2': require('./CD.2.json'),
  'CD.3': require('./CD.3.json'),
  'CD.4': require('./CD.4.json'),
  'CD.5': require('./CD.5.json'),
  'CD.6': require('./CD.6.json'),
  'CD': require('./CD.json'),
  'CE.1': require('./CE.1.json'),
  'CE.2': require('./CE.2.json'),
  'CE.3': require('./CE.3.json'),
  'CE.4': require('./CE.4.json'),
  'CE.5': require('./CE.5.json'),
  'CE.6': require('./CE.6.json'),
  'CE': require('./CE.json'),
  'CF.1': require('./CF.1.json'),
  'CF.2': require('./CF.2.json'),
  'CF.3': require('./CF.3.json'),
  'CF.4': require('./CF.4.json'),
  'CF.5': require('./CF.5.json'),
  'CF.6': require('./CF.6.json'),
  'CF': require('./CF.json'),
  'CNE.1': require('./CNE.1.json'),
  'CNE.2': require('./CNE.2.json'),
  'CNE.3': require('./CNE.3.json'),
  'CNE.4': require('./CNE.4.json'),
  'CNE.5': require('./CNE.5.json'),
  'CNE.6': require('./CNE.6.json'),
  'CNE.7': require('./CNE.7.json'),
  'CNE.8': require('./CNE.8.json'),
  'CNE.9': require('./CNE.9.json'),
  'CNE': require('./CNE.json'),
  'CNN.1': require('./CNN.1.json'),
  'CNN.10': require('./CNN.10.json'),
  'CNN.11': require('./CNN.11.json'),
  'CNN.2': require('./CNN.2.json'),
  'CNN.3': require('./CNN.3.json'),
  'CNN.4': require('./CNN.4.json'),
  'CNN.5': require('./CNN.5.json'),
  'CNN.6': require('./CNN.6.json'),
  'CNN.7': require('./CNN.7.json'),
  'CNN.8': require('./CNN.8.json'),
  'CNN.9': require('./CNN.9.json'),
  'CNN': require('./CNN.json'),
  'CP.1': require('./CP.1.json'),
  'CP.2': require('./CP.2.json'),
  'CP.3': require('./CP.3.json'),
  'CP.4': require('./CP.4.json'),
  'CP.5': require('./CP.5.json'),
  'CP.6': require('./CP.6.json'),
  'CP': require('./CP.json'),
  'CQ.1': require('./CQ.1.json'),
  'CQ.2': require('./CQ.2.json'),
  'CQ': require('./CQ.json'),
  'CSU.1': require('./CSU.1.json'),
  'CSU.2': require('./CSU.2.json'),
  'CSU.3': require('./CSU.3.json'),
  'CSU.4': require('./CSU.4.json'),
  'CSU.5': require('./CSU.5.json'),
  'CSU.6': require('./CSU.6.json'),
  'CSU.7': require('./CSU.7.json'),
  'CSU': require('./CSU.json'),
  'CWE.1': require('./CWE.1.json'),
  'CWE.2': require('./CWE.2.json'),
  'CWE.3': require('./CWE.3.json'),
  'CWE.4': require('./CWE.4.json'),
  'CWE.5': require('./CWE.5.json'),
  'CWE.6': require('./CWE.6.json'),
  'CWE.7': require('./CWE.7.json'),
  'CWE.8': require('./CWE.8.json'),
  'CWE.9': require('./CWE.9.json'),
  'CWE': require('./CWE.json'),
  'CX.1': require('./CX.1.json'),
  'CX.10': require('./CX.10.json'),
  'CX.2': require('./CX.2.json'),
  'CX.3': require('./CX.3.json'),
  'CX.4': require('./CX.4.json'),
  'CX.5': require('./CX.5.json'),
  'CX.6': require('./CX.6.json'),
  'CX.7': require('./CX.7.json'),
  'CX.8': require('./CX.8.json'),
  'CX.9': require('./CX.9.json'),
  'CX': require('./CX.json'),
  'DDI.1': require('./DDI.1.json'),
  'DDI.2': require('./DDI.2.json'),
  'DDI.3': require('./DDI.3.json'),
  'DDI': require('./DDI.json'),
  'DIN.1': require('./DIN.1.json'),
  'DIN.2': require('./DIN.2.json'),
  'DIN': require('./DIN.json'),
  'DLD.1': require('./DLD.1.json'),
  'DLD.2': require('./DLD.2.json'),
  'DLD': require('./DLD.json'),
  'DLN.1': require('./DLN.1.json'),
  'DLN.2': require('./DLN.2.json'),
  'DLN.3': require('./DLN.3.json'),
  'DLN': require('./DLN.json'),
  'DLT.1': require('./DLT.1.json'),
  'DLT.2': require('./DLT.2.json'),
  'DLT.3': require('./DLT.3.json'),
  'DLT.4': require('./DLT.4.json'),
  'DLT': require('./DLT.json'),
  'DR.1': require('./DR.1.json'),
  'DR.2': require('./DR.2.json'),
  'DR': require('./DR.json'),
  'DT': require('./DT.json'),
  'DTM': require('./DTM.json'),
  'DTN.1': require('./DTN.1.json'),
  'DTN.2': require('./DTN.2.json'),
  'DTN': require('./DTN.json'),
  'ED.1': require('./ED.1.json'),
  'ED.2': require('./ED.2.json'),
  'ED.3': require('./ED.3.json'),
  'ED.4': require('./ED.4.json'),
  'ED.5': require('./ED.5.json'),
  'ED': require('./ED.json'),
  'EI.1': require('./EI.1.json'),
  'EI.2': require('./EI.2.json'),
  'EI.3': require('./EI.3.json'),
  'EI.4': require('./EI.4.json'),
  'EI': require('./EI.json'),
  'EIP.1': require('./EIP.1.json'),
  'EIP.2': require('./EIP.2.json'),
  'EIP': require('./EIP.json'),
  'ELD.1': require('./ELD.1.json'),
  'ELD.2': require('./ELD.2.json'),
  'ELD.3': require('./ELD.3.json'),
  'ELD.4': require('./ELD.4.json'),
  'ELD': require('./ELD.json'),
  'ERL.1': require('./ERL.1.json'),
  'ERL.2': require('./ERL.2.json'),
  'ERL.3': require('./ERL.3.json'),
  'ERL.4': require('./ERL.4.json'),
  'ERL.5': require('./ERL.5.json'),
  'ERL.6': require('./ERL.6.json'),
  'ERL': require('./ERL.json'),
  'FC.1': require('./FC.1.json'),
  'FC.2': require('./FC.2.json'),
  'FC': require('./FC.json'),
  'FN.1': require('./FN.1.json'),
  'FN.2': require('./FN.2.json'),
  'FN.3': require('./FN.3.json'),
  'FN.4': require('./FN.4.json'),
  'FN.5': require('./FN.5.json'),
  'FN': require('./FN.json'),
  'FT': require('./FT.json'),
  'GTS': require('./GTS.json'),
  'HD.1': require('./HD.1.json'),
  'HD.2': require('./HD.2.json'),
  'HD.3': require('./HD.3.json'),
  'HD': require('./HD.json'),
  'ICD.1': require('./ICD.1.json'),
  'ICD.2': require('./ICD.2.json'),
  'ICD.3': require('./ICD.3.json'),
  'ICD': require('./ICD.json'),
  'ID': require('./ID.json'),
  'IS': require('./IS.json'),
  'JCC.1': require('./JCC.1.json'),
  'JCC.2': require('./JCC.2.json'),
  'JCC.3': require('./JCC.3.json'),
  'JCC': require('./JCC.json'),
  'LA1.1': require('./LA1.1.json'),
  'LA1.2': require('./LA1.2.json'),
  'LA1.3': require('./LA1.3.json'),
  'LA1.4': require('./LA1.4.json'),
  'LA1.5': require('./LA1.5.json'),
  'LA1.6': require('./LA1.6.json'),
  'LA1.7': require('./LA1.7.json'),
  'LA1.8': require('./LA1.8.json'),
  'LA1.9': require('./LA1.9.json'),
  'LA1': require('./LA1.json'),
  'LA2.1': require('./LA2.1.json'),
  'LA2.10': require('./LA2.10.json'),
  'LA2.11': require('./LA2.11.json'),
  'LA2.12': require('./LA2.12.json'),
  'LA2.13': require('./LA2.13.json'),
  'LA2.14': require('./LA2.14.json'),
  'LA2.15': require('./LA2.15.json'),
  'LA2.16': require('./LA2.16.json'),
  'LA2.2': require('./LA2.2.json'),
  'LA2.3': require('./LA2.3.json'),
  'LA2.4': require('./LA2.4.json'),
  'LA2.5': require('./LA2.5.json'),
  'LA2.6': require('./LA2.6.json'),
  'LA2.7': require('./LA2.7.json'),
  'LA2.8': require('./LA2.8.json'),
  'LA2.9': require('./LA2.9.json'),
  'LA2': require('./LA2.json'),
  'MA.1': require('./MA.1.json'),
  'MA.2': require('./MA.2.json'),
  'MA.3': require('./MA.3.json'),
  'MA.4': require('./MA.4.json'),
  'MA.5': require('./MA.5.json'),
  'MA.6': require('./MA.6.json'),
  'MA': require('./MA.json'),
  'MO.1': require('./MO.1.json'),
  'MO.2': require('./MO.2.json'),
  'MO': require('./MO.json'),
  'MOC.1': require('./MOC.1.json'),
  'MOC.2': require('./MOC.2.json'),
  'MOC': require('./MOC.json'),
  'MOP.1': require('./MOP.1.json'),
  'MOP.2': require('./MOP.2.json'),
  'MOP.3': require('./MOP.3.json'),
  'MOP': require('./MOP.json'),
  'MSG.1': require('./MSG.1.json'),
  'MSG.2': require('./MSG.2.json'),
  'MSG.3': require('./MSG.3.json'),
  'MSG': require('./MSG.json'),
  'NA.1': require('./NA.1.json'),
  'NA.2': require('./NA.2.json'),
  'NA.3': require('./NA.3.json'),
  'NA.4': require('./NA.4.json'),
  'NA': require('./NA.json'),
  'NDL.1': require('./NDL.1.json'),
  'NDL.10': require('./NDL.10.json'),
  'NDL.11': require('./NDL.11.json'),
  'NDL.2': require('./NDL.2.json'),
  'NDL.3': require('./NDL.3.json'),
  'NDL.4': require('./NDL.4.json'),
  'NDL.5': require('./NDL.5.json'),
  'NDL.6': require('./NDL.6.json'),
  'NDL.7': require('./NDL.7.json'),
  'NDL.8': require('./NDL.8.json'),
  'NDL.9': require('./NDL.9.json'),
  'NDL': require('./NDL.json'),
  'NM': require('./NM.json'),
  'NR.1': require('./NR.1.json'),
  'NR.2': require('./NR.2.json'),
  'NR': require('./NR.json'),
  'NUL': require('./NUL.json'),
  'OCD.1': require('./OCD.1.json'),
  'OCD.2': require('./OCD.2.json'),
  'OCD': require('./OCD.json'),
  'OSD.1': require('./OSD.1.json'),
  'OSD.10': require('./OSD.10.json'),
  'OSD.11': require('./OSD.11.json'),
  'OSD.2': require('./OSD.2.json'),
  'OSD.3': require('./OSD.3.json'),
  'OSD.4': require('./OSD.4.json'),
  'OSD.5': require('./OSD.5.json'),
  'OSD.6': require('./OSD.6.json'),
  'OSD.7': require('./OSD.7.json'),
  'OSD.8': require('./OSD.8.json'),
  'OSD.9': require('./OSD.9.json'),
  'OSD': require('./OSD.json'),
  'OSP.1': require('./OSP.1.json'),
  'OSP.2': require('./OSP.2.json'),
  'OSP.3': require('./OSP.3.json'),
  'OSP': require('./OSP.json'),
  'PIP.1': require('./PIP.1.json'),
  'PIP.2': require('./PIP.2.json'),
  'PIP.3': require('./PIP.3.json'),
  'PIP.4': require('./PIP.4.json'),
  'PIP.5': require('./PIP.5.json'),
  'PIP': require('./PIP.json'),
  'PL.1': require('./PL.1.json'),
  'PL.10': require('./PL.10.json'),
  'PL.11': require('./PL.11.json'),
  'PL.2': require('./PL.2.json'),
  'PL.3': require('./PL.3.json'),
  'PL.4': require('./PL.4.json'),
  'PL.5': require('./PL.5.json'),
  'PL.6': require('./PL.6.json'),
  'PL.7': require('./PL.7.json'),
  'PL.8': require('./PL.8.json'),
  'PL.9': require('./PL.9.json'),
  'PL': require('./PL.json'),
  'PLN.1': require('./PLN.1.json'),
  'PLN.2': require('./PLN.2.json'),
  'PLN.3': require('./PLN.3.json'),
  'PLN.4': require('./PLN.4.json'),
  'PLN': require('./PLN.json'),
  'PPN.1': require('./PPN.1.json'),
  'PPN.10': require('./PPN.10.json'),
  'PPN.11': require('./PPN.11.json'),
  'PPN.12': require('./PPN.12.json'),
  'PPN.13': require('./PPN.13.json'),
  'PPN.14': require('./PPN.14.json'),
  'PPN.15': require('./PPN.15.json'),
  'PPN.16': require('./PPN.16.json'),
  'PPN.17': require('./PPN.17.json'),
  'PPN.18': require('./PPN.18.json'),
  'PPN.19': require('./PPN.19.json'),
  'PPN.2': require('./PPN.2.json'),
  'PPN.20': require('./PPN.20.json'),
  'PPN.21': require('./PPN.21.json'),
  'PPN.22': require('./PPN.22.json'),
  'PPN.23': require('./PPN.23.json'),
  'PPN.24': require('./PPN.24.json'),
  'PPN.3': require('./PPN.3.json'),
  'PPN.4': require('./PPN.4.json'),
  'PPN.5': require('./PPN.5.json'),
  'PPN.6': require('./PPN.6.json'),
  'PPN.7': require('./PPN.7.json'),
  'PPN.8': require('./PPN.8.json'),
  'PPN.9': require('./PPN.9.json'),
  'PPN': require('./PPN.json'),
  'PRL.1': require('./PRL.1.json'),
  'PRL.2': require('./PRL.2.json'),
  'PRL.3': require('./PRL.3.json'),
  'PRL': require('./PRL.json'),
  'PT.1': require('./PT.1.json'),
  'PT.2': require('./PT.2.json'),
  'PT': require('./PT.json'),
  'PTA.1': require('./PTA.1.json'),
  'PTA.2': require('./PTA.2.json'),
  'PTA.3': require('./PTA.3.json'),
  'PTA.4': require('./PTA.4.json'),
  'PTA': require('./PTA.json'),
  'QIP.1': require('./QIP.1.json'),
  'QIP.2': require('./QIP.2.json'),
  'QIP': require('./QIP.json'),
  'QSC.1': require('./QSC.1.json'),
  'QSC.2': require('./QSC.2.json'),
  'QSC.3': require('./QSC.3.json'),
  'QSC.4': require('./QSC.4.json'),
  'QSC': require('./QSC.json'),
  'RCD.1': require('./RCD.1.json'),
  'RCD.2': require('./RCD.2.json'),
  'RCD.3': require('./RCD.3.json'),
  'RCD': require('./RCD.json'),
  'RFR.1': require('./RFR.1.json'),
  'RFR.2': require('./RFR.2.json'),
  'RFR.3': require('./RFR.3.json'),
  'RFR.4': require('./RFR.4.json'),
  'RFR.5': require('./RFR.5.json'),
  'RFR.6': require('./RFR.6.json'),
  'RFR.7': require('./RFR.7.json'),
  'RFR': require('./RFR.json'),
  'RI.1': require('./RI.1.json'),
  'RI.2': require('./RI.2.json'),
  'RI': require('./RI.json'),
  'RMC.1': require('./RMC.1.json'),
  'RMC.2': require('./RMC.2.json'),
  'RMC.3': require('./RMC.3.json'),
  'RMC.4': require('./RMC.4.json'),
  'RMC': require('./RMC.json'),
  'RP.1': require('./RP.1.json'),
  'RP.2': require('./RP.2.json'),
  'RP.3': require('./RP.3.json'),
  'RP.4': require('./RP.4.json'),
  'RP': require('./RP.json'),
  'RPT.1': require('./RPT.1.json'),
  'RPT.10': require('./RPT.10.json'),
  'RPT.11': require('./RPT.11.json'),
  'RPT.2': require('./RPT.2.json'),
  'RPT.3': require('./RPT.3.json'),
  'RPT.4': require('./RPT.4.json'),
  'RPT.5': require('./RPT.5.json'),
  'RPT.6': require('./RPT.6.json'),
  'RPT.7': require('./RPT.7.json'),
  'RPT.8': require('./RPT.8.json'),
  'RPT.9': require('./RPT.9.json'),
  'RPT': require('./RPT.json'),
  'SAD.1': require('./SAD.1.json'),
  'SAD.2': require('./SAD.2.json'),
  'SAD.3': require('./SAD.3.json'),
  'SAD': require('./SAD.json'),
  'SCV.1': require('./SCV.1.json'),
  'SCV.2': require('./SCV.2.json'),
  'SCV': require('./SCV.json'),
  'SI': require('./SI.json'),
  'SN.1': require('./SN.1.json'),
  'SN.2': require('./SN.2.json'),
  'SN.3': require('./SN.3.json'),
  'SN.4': require('./SN.4.json'),
  'SN': require('./SN.json'),
  'SPD.1': require('./SPD.1.json'),
  'SPD.2': require('./SPD.2.json'),
  'SPD.3': require('./SPD.3.json'),
  'SPD.4': require('./SPD.4.json'),
  'SPD': require('./SPD.json'),
  'SPS.1': require('./SPS.1.json'),
  'SPS.2': require('./SPS.2.json'),
  'SPS.3': require('./SPS.3.json'),
  'SPS.4': require('./SPS.4.json'),
  'SPS.5': require('./SPS.5.json'),
  'SPS.6': require('./SPS.6.json'),
  'SPS.7': require('./SPS.7.json'),
  'SPS': require('./SPS.json'),
  'SRT.1': require('./SRT.1.json'),
  'SRT.2': require('./SRT.2.json'),
  'SRT': require('./SRT.json'),
  'ST': require('./ST.json'),
  'TM': require('./TM.json'),
  'TQ.1': require('./TQ.1.json'),
  'TQ.10': require('./TQ.10.json'),
  'TQ.11': require('./TQ.11.json'),
  'TQ.12': require('./TQ.12.json'),
  'TQ.2': require('./TQ.2.json'),
  'TQ.3': require('./TQ.3.json'),
  'TQ.4': require('./TQ.4.json'),
  'TQ.5': require('./TQ.5.json'),
  'TQ.6': require('./TQ.6.json'),
  'TQ.7': require('./TQ.7.json'),
  'TQ.8': require('./TQ.8.json'),
  'TQ.9': require('./TQ.9.json'),
  'TQ': require('./TQ.json'),
  'TS.1': require('./TS.1.json'),
  'TS.2': require('./TS.2.json'),
  'TS': require('./TS.json'),
  'TX': require('./TX.json'),
  'UVC.1': require('./UVC.1.json'),
  'UVC.2': require('./UVC.2.json'),
  'UVC': require('./UVC.json'),
  'VH.1': require('./VH.1.json'),
  'VH.2': require('./VH.2.json'),
  'VH.3': require('./VH.3.json'),
  'VH.4': require('./VH.4.json'),
  'VH': require('./VH.json'),
  'VID.1': require('./VID.1.json'),
  'VID.2': require('./VID.2.json'),
  'VID.3': require('./VID.3.json'),
  'VID': require('./VID.json'),
  'VR.1': require('./VR.1.json'),
  'VR.2': require('./VR.2.json'),
  'VR': require('./VR.json'),
  'WVI.1': require('./WVI.1.json'),
  'WVI.2': require('./WVI.2.json'),
  'WVI': require('./WVI.json'),
  'WVS.1': require('./WVS.1.json'),
  'WVS.2': require('./WVS.2.json'),
  'WVS': require('./WVS.json'),
  'XAD.1': require('./XAD.1.json'),
  'XAD.10': require('./XAD.10.json'),
  'XAD.11': require('./XAD.11.json'),
  'XAD.12': require('./XAD.12.json'),
  'XAD.13': require('./XAD.13.json'),
  'XAD.14': require('./XAD.14.json'),
  'XAD.2': require('./XAD.2.json'),
  'XAD.3': require('./XAD.3.json'),
  'XAD.4': require('./XAD.4.json'),
  'XAD.5': require('./XAD.5.json'),
  'XAD.6': require('./XAD.6.json'),
  'XAD.7': require('./XAD.7.json'),
  'XAD.8': require('./XAD.8.json'),
  'XAD.9': require('./XAD.9.json'),
  'XAD': require('./XAD.json'),
  'XCN.1': require('./XCN.1.json'),
  'XCN.10': require('./XCN.10.json'),
  'XCN.11': require('./XCN.11.json'),
  'XCN.12': require('./XCN.12.json'),
  'XCN.13': require('./XCN.13.json'),
  'XCN.14': require('./XCN.14.json'),
  'XCN.15': require('./XCN.15.json'),
  'XCN.16': require('./XCN.16.json'),
  'XCN.17': require('./XCN.17.json'),
  'XCN.18': require('./XCN.18.json'),
  'XCN.19': require('./XCN.19.json'),
  'XCN.2': require('./XCN.2.json'),
  'XCN.20': require('./XCN.20.json'),
  'XCN.21': require('./XCN.21.json'),
  'XCN.22': require('./XCN.22.json'),
  'XCN.23': require('./XCN.23.json'),
  'XCN.3': require('./XCN.3.json'),
  'XCN.4': require('./XCN.4.json'),
  'XCN.5': require('./XCN.5.json'),
  'XCN.6': require('./XCN.6.json'),
  'XCN.7': require('./XCN.7.json'),
  'XCN.8': require('./XCN.8.json'),
  'XCN.9': require('./XCN.9.json'),
  'XCN': require('./XCN.json'),
  'XON.1': require('./XON.1.json'),
  'XON.10': require('./XON.10.json'),
  'XON.2': require('./XON.2.json'),
  'XON.3': require('./XON.3.json'),
  'XON.4': require('./XON.4.json'),
  'XON.5': require('./XON.5.json'),
  'XON.6': require('./XON.6.json'),
  'XON.7': require('./XON.7.json'),
  'XON.8': require('./XON.8.json'),
  'XON.9': require('./XON.9.json'),
  'XON': require('./XON.json'),
  'XPN.1': require('./XPN.1.json'),
  'XPN.10': require('./XPN.10.json'),
  'XPN.11': require('./XPN.11.json'),
  'XPN.12': require('./XPN.12.json'),
  'XPN.13': require('./XPN.13.json'),
  'XPN.14': require('./XPN.14.json'),
  'XPN.2': require('./XPN.2.json'),
  'XPN.3': require('./XPN.3.json'),
  'XPN.4': require('./XPN.4.json'),
  'XPN.5': require('./XPN.5.json'),
  'XPN.6': require('./XPN.6.json'),
  'XPN.7': require('./XPN.7.json'),
  'XPN.8': require('./XPN.8.json'),
  'XPN.9': require('./XPN.9.json'),
  'XPN': require('./XPN.json'),
  'XTN.1': require('./XTN.1.json'),
  'XTN.10': require('./XTN.10.json'),
  'XTN.11': require('./XTN.11.json'),
  'XTN.12': require('./XTN.12.json'),
  'XTN.2': require('./XTN.2.json'),
  'XTN.3': require('./XTN.3.json'),
  'XTN.4': require('./XTN.4.json'),
  'XTN.5': require('./XTN.5.json'),
  'XTN.6': require('./XTN.6.json'),
  'XTN.7': require('./XTN.7.json'),
  'XTN.8': require('./XTN.8.json'),
  'XTN.9': require('./XTN.9.json'),
  'XTN': require('./XTN.json'),
  'escapeType': require('./escapeType.json'),
  'varies': require('./varies.json'),
};